import React = require("react");
import {BarChart} from "../charts/BarChart";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {Display} from "../../../components/Display";
import {EmptyState, infoIcons} from "@vebox/etui-core";
import AutoSizer from "react-virtualized-auto-sizer";

declare var AppTranslations: AppTranslations;

interface HistogramChartWidgetEntityData {
    name: string;
    value: number;
    color: string;
}


interface HistogramChartWidgetProps {
    title: string;
    yUnitOfMeasure: string;
    data: HistogramChartWidgetEntityData[];
}

export class LargeHistogramChartWidget extends React.Component<HistogramChartWidgetProps, any> {

    constructor(props: HistogramChartWidgetProps) {
        super(props);
    }

    public render() {
        return (
            <VeBoxCard className="marketing-widget marketing-widget-large no-margin">
                <VeBoxCard.Header title={this.props.title}/>
                <VeBoxCard.Body className="marketing-widget__content">
                    <Display isVisible={this.props.data.length === 0}>
                        <EmptyState>
                            <EmptyState.InfoIcon
                                styles={{
                                    root: {
                                        color: "var(--empty-indicator-svg-stroke)",
                                    }
                                }}
                                glyph={infoIcons.NoContent}
                            />
                            <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.noDataAvailable}</EmptyState.Title>
                            <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                        </EmptyState>
                    </Display>
                    <Display isVisible={this.props.data.length > 0}>
                        <AutoSizer disableHeight style={{width: "auto", height: "auto"}}>
                            {({width}) =>
                                <BarChart
                                    width={width - 20}
                                    height={430}
                                    color={null}
                                    data={this.props.data}
                                    yUnitOfMeasure={this.props.yUnitOfMeasure}
                                />
                            }
                        </AutoSizer>
                    </Display>
                </VeBoxCard.Body>
            </VeBoxCard>
        );
    }
}
